import { ChangeEvent, useState } from "react";
import { PageableResponse } from "../../../../models/response.model";
import { IAlunosTableDTO } from "../../../../models/happy-code-api.model";
import "./aluno-table.css";
import useAlunoTable from "./use-aluno-table.hook";
import GenericPageableTable from "../../../../components/GenericPageableTable/generic-pageable-table.component";
import { useAlunoTableColumns } from "./aluno-table.columns";
import { IAlunoTable } from "../../interfaces/aluno-table.interface";
import AlunoModal from "../AlunoModal";
import { boxTurmaInformacaoStore } from "../../store/box-turma-informacao.store";

interface AlunoTableProps {
  alunosTableData: PageableResponse<IAlunosTableDTO>;
  onPageChange: (event: ChangeEvent<unknown>, page: number) => void;
}

export default function AlunoTable({
  alunosTableData,
  onPageChange,
}: AlunoTableProps) {
  const { handledAlunoTableData } = useAlunoTable({ alunosTableData });
  const [isAlunoModalOpen, setIsAlunoModalOpen] = useState(false);
  const [selectedAluno, setSelectedAluno] = useState<IAlunoTable | null>(null);
  const idTurma = boxTurmaInformacaoStore((state) => state.boxTurmaInformacao.id);



  const columns = useAlunoTableColumns({
    onOpenAlunoModal: (item) => {
      if(!item.codigo) return
      setSelectedAluno(item);
      setIsAlunoModalOpen(true);
    },
  });

  return (
    <>
      <GenericPageableTable
        data={handledAlunoTableData}
        columns={columns}
        onPageChange={onPageChange}
      />
      <AlunoModal
        idTurma={idTurma}
        open={isAlunoModalOpen}
        onClose={() => setIsAlunoModalOpen(false)}
        aluno={selectedAluno}
      />
    </>
  );
}

